import React from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import ItemTestimonial from './itemTestimonial'
import { AnimatePresence, motion } from 'framer-motion'
// styles
import './styles.ttm.scss'

export default function Testimonials({ data }) {
  const subTitle = get(data, ['subTitle'], '')
  const title = get(data, ['title'], '')
  const listTestimonials = get(data, ['listTestimonials'], [])

  return (
    <section className="mainSectionTestimonials">
      <div className="containerTestimonials">
        <motion.div
          transition={{
            duration: 0.7,
            delay: 0.1,
          }}
          viewport={{
            once: true,
          }}
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          exit={{ opacity: 1 }}
          className="containerTitles"
        >
          <pre>{subTitle}</pre>
          <h2>{title}</h2>
        </motion.div>
        <div className="containerListTestimonials">
          <AnimatePresence>
            {listTestimonials.map((value, key) => (
              <ItemTestimonial
                index={key}
                data={value.itemTestimonial}
                key={`ItemTestimonial_${key}`}
              />
            ))}
          </AnimatePresence>
        </div>
      </div>
    </section>
  )
}

Testimonials.propTypes = {
  data: PropTypes.object,
}
